export const Fallback = () => (
  <div className="text-h1 text-foreground-quinary flex w-full flex-1 animate-pulse items-center justify-center font-black">
    <div>Wayfarer</div>
  </div>
)
